module.exports = __webpack_public_path__ + "img/emo_58.068f8023.png";